import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ThreePillars from './components/ThreePillars';
import Services from './components/Services';
import Story from './components/Story';
import Contact, { Footer } from './components/Contact';
import ServiceDetail from './components/ServiceDetail';
import AdminInquiries from './components/AdminInquiries';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#020617]">
      <Navbar />
      <Hero />
      <ThreePillars />
      <Services />
      <About />
      <Story />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
